'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const BannerOfferColumn = renderWithRef('BannerOfferColumn', null, (n, o)=>{
    let { children: t } = n;
    return jsx(RenderComp, {
        root: "div",
        forwardedRef: o,
        classNames: [
            'swan-banner-offer-column'
        ],
        props: n,
        children: t
    });
});

export { BannerOfferColumn };
